import * as React from 'react';

import cn from 'classnames';

import { Translate } from '@decorators';

import { Icon } from '@components/Icon';

import {
	IconBrandClose,
	IconBrandLogotype,
	IconBrandMenu,
} from '@icons';

import {
	EBrandFileName,
	EBrandMenuItem,
	EBrandScreen,
} from '../../enums';
import { BrandDownloadPanel } from '../BrandDownloadPanel';
import { BrandMenu } from '../BrandMenu';

import { IBrandHeaderProps, IBrandHeaderState } from './types';

import * as s from './BrandHeader.scss';

@Translate('common.containers.Brand.components.BrandHeader')
export class BrandHeader extends React.Component<IBrandHeaderProps, IBrandHeaderState> {

	state: IBrandHeaderState = {
		isMenuOpen: false,
	};

	getActiveMenuItem() {
		const screen = Object.values(EBrandScreen).find((screenId: EBrandScreen) => {
			const screenEl = document.getElementById(screenId);
			return screenEl.offsetTop + screenEl.offsetHeight > window.scrollY;
		});

		if (screen === EBrandScreen.LOGOGRAM) {
			return EBrandMenuItem.LOGOTYPE;
		}

		if (screen === EBrandScreen.PATTERNS || screen === EBrandScreen.GRADIENTS) {
			return EBrandMenuItem.ILLUSTRATIONS;
		}

		return screen as unknown as EBrandMenuItem;
	}

	openMenu() {
		const {
			onMenuShow,
		} = this.props;

		this.setState({
			isMenuOpen: true,
		});

		onMenuShow();
	}

	closeMenu() {
		const {
			onMenuHide,
		} = this.props;

		this.setState({
			isMenuOpen: false,
		});

		onMenuHide();
	}

	onMenuOpenButtonClick = () => {
		this.openMenu();
	};

	onMenuCloseButtonClick = () => {
		this.closeMenu();
	};

	onMenuItemSelect = (id: EBrandMenuItem) => {
		const {
			onMenuItemSelect,
		} = this.props;

		this.closeMenu();

		onMenuItemSelect(id);
	};

	renderDownloadPanel() {
		const {
			brand,
			urls,
			onDownloadAllButtonClick,
		} = this.props;

		return (
			<BrandDownloadPanel
				linkUrl={`${urls.brandDownload}/${EBrandFileName.ALL}.zip`}
				fileSize={brand.fileSizes.all}
				classNames={{
					block: s.downloadPanel,
				}}
				title={this.t('downloadAllMaterials')}
				onClick={onDownloadAllButtonClick}
			/>
		);
	}

	render() {
		const {
			isMobile,
			isHeaderVisible,
			classNames: {
				content: contentClassName,
			},
		} = this.props;
		const {
			isMenuOpen,
		} = this.state;

		const isVisible = {
			menuOpenButton: !isMenuOpen,
			menuCloseButton: isMenuOpen,
			menu: isMenuOpen,
			downloadPanelAtHeader: !isMobile,
			downloadPanelAtMenu: isMobile,
		};

		return (
			<div className={cn(s.block, {
				[s.isMenuOpen]: isMenuOpen,
				[s.isHeaderHidden]: !isHeaderVisible,
			})}>
				<div className={cn(s.content, contentClassName)}>
					<Icon glyph={IconBrandLogotype} className={s.logo} />

					{isVisible.downloadPanelAtHeader && this.renderDownloadPanel()}

					{isVisible.menuOpenButton &&
						<Icon
							glyph={IconBrandMenu}
							className={s.menuOpenButton}
							onClick={this.onMenuOpenButtonClick}
						/>
					}

					{isVisible.menuCloseButton &&
						<Icon
							glyph={IconBrandClose}
							className={s.menuCloseButton}
							onClick={this.onMenuCloseButtonClick}
						/>
					}
				</div>

				{isVisible.menu &&
					<div className={s.menu}>
						<BrandMenu
							isMobile={isMobile}
							activeMenuItem={this.getActiveMenuItem()}
							className={cn(s.menuContent, contentClassName)}
							onSelect={this.onMenuItemSelect}
						/>

						{isVisible.downloadPanelAtMenu && this.renderDownloadPanel()}
					</div>

				}
			</div>
		);
	}

}
